import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import moment from 'moment';
import { AgreementActionType } from '@enums/agreement/agreementActionType.enum';
import { Util } from '@enums/util.enum';
import { HelperService } from '@services/helper.service';

@Component({
  selector: 'app-expire-dialog',
  templateUrl: './expire-dialog.component.html',
  styleUrls: ['./expire-dialog.component.scss'],
})
export class ExpireDialogComponent implements OnInit {
  actionMinDate: number;
  actionMaxDate: number;
  lessThanEffectiveDate: boolean = false;
  lessThanExpiryDate: boolean = false;
  moreThanExpiryDate: boolean = false;

  agreementActionType = AgreementActionType;
  readonly util = Util;
  constructor(
    public dialogRef: MatDialogRef<ExpireDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    switch (this.data.action) {
      case AgreementActionType.EXPIRY:
        this.actionMinDate = this.data.effectiveDate;
        this.actionMaxDate = this.data.expiryDate ?? Util.DefaultDate;
        break;
      case AgreementActionType.EXTEND:
        this.actionMinDate = this.data.expiryDate ?? Util.DefaultDate;
        break;
    }
    this.validateInput(new Date(moment(this.data.defaultDate).format('MM/DD/YYYY')).getTime());
  }

  onInputChange(event) {
    const userDate = new Date(event).getTime();
    this.validateInput(userDate);
  }

  validateInput(inputDate: number) {
    this.data.expiryDate = this.helperService.displayDate(this.data.expiryDate);
    this.data.defaultDate = this.helperService.displayDate(this.data.defaultDate);
    switch (this.data.action) {
      case AgreementActionType.EXPIRY:
        this.lessThanEffectiveDate = this.data.effectiveDate
          ? inputDate < new Date(moment(this.data.effectiveDate).format('MM/DD/YYYY')).getTime()
          : false;
        this.moreThanExpiryDate = this.data.expiryDate
          ? inputDate > new Date(moment(this.data.expiryDate).format('MM/DD/YYYY')).getTime() ||
            inputDate === new Date(moment(this.data.expiryDate).format('MM/DD/YYYY')).getTime()
          : false;
        break;
      case AgreementActionType.EXTEND:
        this.lessThanEffectiveDate = this.data.effectiveDate
          ? inputDate < new Date(moment(this.data.effectiveDate).format('MM/DD/YYYY')).getTime()
          : false;
        this.lessThanExpiryDate = this.data.expiryDate
          ? inputDate < new Date(moment(this.data.expiryDate).format('MM/DD/YYYY')).getTime() ||
            inputDate === new Date(moment(this.data.expiryDate).format('MM/DD/YYYY')).getTime()
          : false;
        break;
    }
  }
}
